import { defineAction, object, string } from '~/prix'
import appSebraeMobilityImageProxyAction from './appSebraeMobilityImageProxy.action.json'

const appSebraeMobilityImageProxyDefinition = defineAction({
  ...appSebraeMobilityImageProxyAction,
  input: object({ url: string() }),
  output: object({}),
})

export default appSebraeMobilityImageProxyDefinition
